import { useState } from 'react';
import { useSelector } from 'react-redux';
import useFileHandler from 'hooks/useFileHandler';
import { DeleteOutlined, UploadOutlined } from '@ant-design/icons';
import { App, Button, Form, Upload } from 'antd';

// Solution
// https://file.lynorg.com/lynorg-service/endpoint/filemngt/upload-file-solution
// Doc-Hub
// https://file.lynorg.com/lynorg-service/endpoint/file/upload-awareness

const FileUpload = ({ screen = 'VIEW', name, processCode, existingFieldList, required = false, disabled }) => {
	const { message: messageApi } = App.useApp();
	const auth = useSelector((state) => state.auth);

	const [fileList, setFileList] = useState(existingFieldList ?? []);

	const { downloadFileHandler, uploadFile } = useFileHandler();

	const uploadFileHandler = async (options) => {
		const formData = new FormData();
		const api = '/upload-file-solution';

		formData.append('file', options?.file);
		formData.append('processCode', processCode);

		await uploadFile(options, formData, api);
	};

	const normFile = (e) => {
		if (Array.isArray(e)) {
			return e;
		}

		// console.log(e.fileList, 'fileList');
		return e?.fileList;
	};

	const props = {
		name: 'file',
		multiple: false,
		headers: {
			token: `Bearer ${auth?.accessToken}`,
		},
		customRequest: (opt) => uploadFileHandler(opt, 'file'),
		onChange: (info) => {
			// console.log("info", info);

			//   onFiledChange(info?.fileList);

			setFileList(info.fileList);
			const status = info?.file?.status;
			if (status === 'done') {
				messageApi.success(`${info.file.name} file uploaded successfully.`);
			} else if (status === 'error') {
				messageApi.error(`${info.file.name} file upload failed.`);
			}

			// return info?.fileList;
		},
		showUploadList: {
			showDownloadIcon: true,
			downloadIcon: 'Download',
			showRemoveIcon: existingFieldList ? false : true,
			removeIcon: <DeleteOutlined style={{ color: 'red' }} />,
		},
		onDownload: (file) => {
			const {
				response: { fileName, fileId },
			} = file;

			const api = '/download-file-solution';
			const payload = {
				fileId,
				processCode,
			};
			downloadFileHandler(payload, fileName, api);
		},
	};

	return (
		// <Form.Item
		// 	label=""
		// 	disabled={disabled}
		// 	rules={[
		// 		{
		// 			required: required,
		// 			message: `Field is required.`,
		// 		},
		// 	]}
		// >
		<Form.Item
			name={name}
			valuePropName="fileList"
			getValueFromEvent={normFile}
			rules={[
				{
					required: required,
					message: `Field is required.`,
				},
			]}
		>
			<Upload {...props} defaultFileList={fileList} style={{ width: '100%' }}>
				<Button disabled={disabled} style={{ width: '100%' }} icon={<UploadOutlined />}>
					Click to Upload
				</Button>
			</Upload>
		</Form.Item>
		// </Form.Item>
	);
};
export default FileUpload;